import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { toast } from "sonner";

const CartCtx = createContext(null);
const KEY = "jt_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return (JSON.parse(localStorage.getItem(KEY)) || []).map((i) => ({ options: {}, key: i.key || i.product_id + "{}", ...i })); } catch { return []; }
  });
  const [open, setOpen] = useState(false);
  useEffect(() => localStorage.setItem(KEY, JSON.stringify(items)), [items]);

  const add = useCallback((p, qty = 1, options = {}, price = p.price) => {
    const key = p.id + JSON.stringify(options);
    setItems((cur) => {
      const ex = cur.find((i) => i.key === key);
      if (ex) return cur.map((i) => (i.key === key ? { ...i, qty: Math.min(20, i.qty + qty) } : i));
      return [...cur, { key, product_id: p.id, slug: p.slug, name: p.name, options, price, image: p.images?.[0]?.url || "", qty }];
    });
    toast.success(`${p.name} added to basket`);
    setOpen(true);
  }, []);
  const setQty = useCallback((key, qty) => setItems((cur) => cur.map((i) => (i.key === key ? { ...i, qty: Math.max(1, Math.min(20, qty)) } : i))), []);
  const remove = useCallback((key) => setItems((cur) => cur.filter((i) => i.key !== key)), []);
  const clear = useCallback(() => setItems([]), []);

  const value = useMemo(() => ({
    items, add, setQty, remove, clear, open, setOpen,
    count: items.reduce((s, i) => s + i.qty, 0),
    subtotal: items.reduce((s, i) => s + i.qty * i.price, 0),
  }), [items, add, setQty, remove, clear, open]);
  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
